export const API_URL = 'http://localhost:3001';
// export const API_URL = 'https://sociopedia-clone0-be.vercel.app';